<template>
    <div>
        <div v-if="loaded">
            <h2 v-if="$route.name === 'reset-password'">Reset your password</h2>
            <template v-else>
                <h2>
                    Welcome to PDFShift!
                    <small>Set your password to continue</small>
                </h2>
                <p style="margin-bottom: 60px">
                    You are almost ready to get started with PDFShift! <br />
                    Just set a password for future connections and you'll be ready!
                </p>
            </template>
            <form @submit.prevent="submit" ref="form" action="account/" data-method="put">
                <fieldset>
                    <div :class="{ 'error': errors.password }">
                        <password-input ref="password" v-model="form.password" name="password" placeholder="New password" required autofocus tabindex="1" />
                        <p v-if="errors.password">{{ errors.password }}</p>
                    </div>
                    <div :class="{ 'error': errors.confirm }">
                        <password-input v-model="form.confirm" name="confirm" placeholder="Confirm your password" required tabindex="2" />
                        <p v-if="errors.confirm">{{ errors.confirm }}</p>
                    </div>
                </fieldset>
                <div>
                    <button-loader :label="buttonLabel" :sending="sending" :disabled="disabled" class="btn-full" tabindex="3" />
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import VueForm from '@/plugins/VueForm'
import ButtonLoader from '@/components/ButtonLoader'
import PasswordInput from '@/components/PasswordInput'

export default {
    components: { ButtonLoader, PasswordInput },
    mixins: [VueForm],
    data () {
        return {
            loaded: false,
            form: {
                password: null,
                confirm: null
            }
        }
    },
    watch: {
        loaded (to) {
            if (to) {
                this.$nextTick(() => {
                    this.$refs.password.focus()
                })
            }
        }
    },
    computed: {
        buttonLabel () {
            return this.$route.name === 'reset-password' ? 'Reset my password' : 'Set my password'
        }
    },
    async created () {
        try {
            const result = await this.$http.post('auth/verify', { token: this.$route.params.token })
            this.$store.dispatch('connect', result.body.token)
            if (this.$route.name === 'one-time-login') {
                await this.$store.dispatch('load')
                this.$router.push({ name: 'dashboard' })
            } else {
                this.loaded = true
                await this.$store.dispatch('load')
            }
        } catch (e) {
            this.$router.push({ name: 'login', query: { expired: true } })
        }
    },
    methods: {
        async processSubmit (body) {
            this.$router.push({ name: 'dashboard' })
        }
    }
}
</script>
